// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0baa9be","453":"e77a7cbc","455":"24a10577"}[chunkId] + ".chunk.js";
};